import React, { FC } from 'react';
import DropzoneField from 'components/DropzoneField';
import { t } from 'i18next';
import { Field } from 'react-final-form';
import validations from 'validations';
import { DOCUMENT_FILES } from 'data/global';
import useUploadIm, { LISTING_IM } from 'hooks/useUploadIm';

type ImFieldProps = { dealRoomId: string };

const ImField: FC<ImFieldProps> = ({ dealRoomId }) => {
  const { uploadListingIm, deleteListingIm } = useUploadIm(dealRoomId);

  return (
    <Field
      accept={DOCUMENT_FILES}
      component={DropzoneField}
      maxFiles={1}
      showApplicationAsIframe
      dropMessage={t('dragAndDropPDForWord')}
      name={LISTING_IM}
      uploadRequest={uploadListingIm}
      deleteRequest={deleteListingIm}
      validate={validations.required()}
    />
  );
};

export default ImField;
